export default __webpack_public_path__ + "static/Montserrat-SemiBold-04af9a9e62bb4c47bd55634f7fedfda3.ttf";